import { useEffect, useState } from 'react';
import { CategoriesContentProps } from 'pages/products/components/bottom-left-content/categories';
import { Breadcrumb, Category } from 'Services/Mongo/Types';
import { SButton } from '@setvi/shared/components';
import { Categories } from 'componentsV2/categiries';
import ChevronRightRoundedIcon from '@material-ui/icons/ChevronRightRounded';
import ExpandMoreRoundedIcon from '@material-ui/icons/ExpandMoreRounded';
import { Box } from '@material-ui/core';
import { DrawerHeaderTitle } from '../components';
import { StyledSearch } from './styled';

const iconStyle = {
  height: 22,
  width: 22
};

interface MobileCategoriesProps extends CategoriesContentProps {
  handleClose: () => void;
}

export const MobileCategories = ({
  selectedCategory,
  onSelectCategory,
  handleClose
}: MobileCategoriesProps) => {
  const [search, setSearch] = useState<string>('');
  const [category, setCategory] = useState(selectedCategory);
  const [expandedCategories, setExpandedCategories] = useState<Breadcrumb[]>(
    []
  );

  const toggleCategoryExpansion = (currCat: Category) => {
    const isExpanded = expandedCategories.find(c => c._id === currCat._id);

    if (isExpanded) {
      setExpandedCategories(prev => prev.filter(c => c._id !== category._id));
    } else {
      // If i click on category i want to expand it and collapse all other categories except the breacumb
      setExpandedCategories(currCat.breadcrumbs);
    }
  };

  const handleSelectCategory = (cat: Category) => {
    setCategory(cat);

    if (cat.children.length) {
      toggleCategoryExpansion(cat);
    }
  };

  useEffect(() => {
    setCategory(selectedCategory);
    setExpandedCategories(selectedCategory?.breadcrumbs || []);
  }, [selectedCategory]);

  return (
    <Box overflow="hidden" height="100%" display="flex" flexDirection="column">
      <Box pb={2} display="flex" justifyContent="space-between">
        <DrawerHeaderTitle
          title="Product Categories"
          handleClose={handleClose}
        />
        <SButton
          variant="text"
          onClick={() => {
            onSelectCategory(null);
            handleClose();
          }}
          disabled={!selectedCategory}
          style={{ minHeight: 'auto', padding: 0 }}>
          Clear
        </SButton>
      </Box>
      <StyledSearch
        searchedValue={search}
        onChange={val => setSearch(val)}
        searchIconSize="14px"
      />
      <Box flex={1} mt={1} overflow="hidden">
        <Box flex={1} overflow="auto" height="100%">
          <Categories
            treeViewProps={{
              defaultCollapseIcon: <ExpandMoreRoundedIcon style={iconStyle} />,
              defaultExpandIcon: <ChevronRightRoundedIcon style={iconStyle} />
            }}
            onSelectCategory={handleSelectCategory}
            expandedCategories={expandedCategories}
            selectedCategory={category}
            search={search}
          />
        </Box>
      </Box>
      <Box py="12px" pb={0}>
        <SButton
          style={{ borderRadius: 120 }}
          fullWidth
          onClick={() => {
            onSelectCategory(category._id);
            handleClose();
          }}>
          Done
        </SButton>
      </Box>
    </Box>
  );
};
